import React, { createContext, useState, useContext, useEffect } from 'react';
import { mockAssets } from '../mock/mockData';

const AssetsContext = createContext();

export const AssetsProvider = ({ children }) => {
  const [assets, setAssets] = useState([]);
  const [selectedAsset, setSelectedAsset] = useState(null);

  // Initialize with mock data
  useEffect(() => {
    setAssets(mockAssets);
  }, []);

  // Get assets for a specific user (client)
  const getUserAssets = (userId) => {
    return assets.filter(asset => asset.ownerId === userId);
  };

  // Get a specific asset by ID
  const getAssetById = (assetId) => {
    return assets.find(asset => asset.id === assetId) || null;
  };

  // Update asset location (for mock movement)
  const updateAssetLocation = (assetId, newLocation) => {
    const updatedAssets = assets.map(asset => 
      asset.id === assetId 
        ? { ...asset, location: newLocation, lastUpdated: new Date().toISOString() } 
        : asset
    );
    setAssets(updatedAssets);
  };

  // Update asset status
  const updateAssetStatus = (assetId, newStatus) => {
    const updatedAssets = assets.map(asset => 
      asset.id === assetId 
        ? { ...asset, status: newStatus, lastUpdated: new Date().toISOString() } 
        : asset
    );
    setAssets(updatedAssets);
  };
  
  // Add a new asset
  const addAsset = (assetData) => {
    // Generate a new unique ID
    const newId = `asset_${Date.now()}`;
    
    // Create the new asset with default values for any missing fields
    const newAsset = {
      id: newId,
      name: assetData.name || 'Unnamed Asset',
      description: assetData.description || '',
      type: assetData.type || 'other',
      value: assetData.value || 0,
      ownerId: assetData.ownerId || '',
      status: assetData.status || 'normal',
      location: assetData.location || { lat: 0, lng: 0 },
      lastUpdated: new Date().toISOString(),
      createdAt: new Date().toISOString()
    };
    
    // Add the new asset to the assets array
    const updatedAssets = [...assets, newAsset];
    setAssets(updatedAssets);
    
    return newAsset;
  };
  
  // Delete an asset
  const deleteAsset = (assetId) => {
    const updatedAssets = assets.filter(asset => asset.id !== assetId);
    setAssets(updatedAssets);
  };

  return (
    <AssetsContext.Provider value={{ 
      assets, 
      selectedAsset,
      setSelectedAsset,
      getUserAssets, 
      getAssetById,
      updateAssetLocation,
      updateAssetStatus,
      addAsset,
      deleteAsset
    }}>
      {children}
    </AssetsContext.Provider>
  );
};

export const useAssets = () => useContext(AssetsContext);

export default AssetsContext;
